import fieldsDescription from '../tools/fieldsDescription.json'
import dataTools from '../tools/data'
import dataDescription from '../tools/dataDescription'

export default {
  methods: {
    // -------------- copy -------------------------

    copyLocalFields(item) {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            this.inputs[field] = dataTools.convertSi2gui(
              this.getFieldType(field),
              item[field]
            )
          } else {
            this.inputs[field] = item[field]
          }
        }
      }
    },

    // ----------------- clear ----------------------

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
        }
      }
    },

    // ------------------ add local fields ---------------------

    addFieldsListToBaseObject(
      baseObject,
      fieldsList,
      parentObject = this.inputs
    ) {
      baseObject.parametricValues = {}
      baseObject.parametricReferences = {}
      for (let field of fieldsList) {
        if (this.getPropertiesDescription()[field] != null) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (
            fieldType === 'enum' ||
            fieldType === 'boolean' ||
            fieldType === 'date'
          ) {
            baseObject[field] = parentObject[field]
          } else if (fieldsDescription[fieldType] != null) {
            baseObject[field] = parentObject[field]
          } else {
            baseObject[field] = dataTools.convertGui2si(
              this.getFieldType(field),
              parentObject[field]
            )
          }
        }
      }
      return baseObject
    },

    // ---------------------- field checks -----------------

    getFieldState(parentObject, fieldName, required) {
      let state = {
        value: true, // do not initialize with null, it means field empty
        message: ''
      }
      let fieldDesc = this.getPropertiesDescription()[fieldName]
      if (fieldDesc == null) {
        state.value = false
        state.message =
          'Internal error : Undefined getPropertiesDescription for ' + fieldName
        return state
      }
      let fieldType = fieldDesc.type
      if (fieldType === 'enum') {
        return this.getEnumFieldState(parentObject, fieldName, required)
      } else if (fieldType === 'boolean') {
        return { value: true }
      } else if (fieldType === 'date') {
        return this.getDateFieldState(parentObject, fieldName)
      } else if (fieldType === 'datetime') {
        return this.getDateTimeFieldState(parentObject, fieldName)
      } else if (
        fieldsDescription[fieldType] != null ||
        fieldType === 'Object'
      ) {
        if (parentObject[fieldName] == null) {
          state.value = !required
        }
      } else {
        this.updateState(
          state,
          this.getFieldValueState(fieldDesc, fieldType, parentObject[fieldName])
        )
        if (state.value === true) {
          if (fieldName.includes('min')) {
            let currentValue = parentObject[fieldName]
            let respectiveMaxValue =
              parentObject[fieldName.replace('min', 'max')]
            if (
              dataTools.isNumber(respectiveMaxValue) &&
              parseFloat(currentValue) > parseFloat(respectiveMaxValue)
            ) {
              state.value = false
              state.message =
                'min (' +
                currentValue +
                ') should be lower than max (' +
                respectiveMaxValue +
                ')'
              return state
            }
          } else if (fieldName.includes('max')) {
            let currentValue = parentObject[fieldName]
            let respectiveMinValue =
              parentObject[fieldName.replace('max', 'min')]
            if (
              dataTools.isNumber(respectiveMinValue) &&
              parseFloat(currentValue) < parseFloat(respectiveMinValue)
            ) {
              state.value = false
              state.message =
                'min (' +
                respectiveMinValue +
                ') should be lower than max (' +
                currentValue +
                ')'
              return state
            }
          }
        }
      }
      return state
    },

    getDateFieldState(parentObject, fieldName) {
      let state = {
        value: true,
        message: ''
      }
      var dateReg = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/
      if (parentObject[fieldName] === '') {
        state.value = null
      } else if (isNaN(Date.parse(parentObject[fieldName]))) {
        state.value = false
        state.message = 'Date format is not valid'
      } else if (parentObject[fieldName].match(dateReg) == null) {
        state.value = false
        state.message = 'Date format is not valid'
      }
      return state
    },

    getDateTimeFieldState(parentObject, fieldName) {
      let state = {
        value: true,
        message: ''
      }
      if (parentObject[fieldName] === '') {
        state.value = null
      } else if (isNaN(Date.parse(parentObject[fieldName]))) {
        state.value = false
        state.message = 'Invalid date'
      }
      return state
    },

    // ---------------------- display parametric in table -----------------

    displayRangeValue(exoData, field) {
      let toDisplay = ''
      if (exoData != null) {
        toDisplay = dataTools.convertSi2Display(
          this.getFieldType(field),
          exoData[field]
        )
      }
      return toDisplay
    },

    displayEnumValue(exoData, field) {
      try {
        let desc = fieldsDescription[exoData.typeName]['properties'][field]
        if (exoData[field] && Array.isArray(exoData[field])) {
          return (
            '[' +
            exoData[field]
              .map((el) => desc['values'].find((val) => val.value === el).text)
              .join(', ') +
            ']'
          )
        } else if (exoData[field]) {
          return desc['values'].find((el) => el.value === exoData[field]).text
        }
      } catch (e) {
        return 'undefined'
      }
    },

    displayRefValue(exoData, field) {
      let toDisplay = ''
      if (exoData[field] != null && exoData[field].displayedName != null) {
        toDisplay = exoData[field].displayedName
      }
      return toDisplay
    }
  }
}
